import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index.js";
import App from "./App.vue";
import Products from "./components/Products.vue";
import Cart from "./components/Cart.vue";
import Perguntas from "./components/Perguntas.vue";
import ProdutoUnico from "./components/ProdutoUnico.vue";
import FinalizadoLogin from "./components/FinalizadoLogin.vue";
import FinalizadoSemCadastro from "./components/FinalizadoSemCadastro.vue";
import Cadastro from "./components/Cadastro.vue";
import Endereco from "./components/Endereco.vue";
import Login from "./components/Login.vue";
import AlterarEmail from "./components/AlterarEmail.vue";
import AlterarSenha from "./components/AlterarSenha.vue";
import Sobre from "./components/Sobre.vue";
import ListaEndereco from "./components/ListaEndereco.vue";
import EsqueciSenha from "./components/EsqueciSenha.vue";
import PerguntasPizza from "./components/PerguntasPizza.vue";
import PagamentoPix from "./components/PagamentoPix.vue";
import "semantic-ui-css/semantic.css";
import "./registerServiceWorker";
import VueAnalytics from "vue-analytics";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Cleave from "cleave.js";

library.add(faUserSecret);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueRouter);

// Define routes
const routes = [
  { path: "/login", component: Login },
  { path: "/sobre", component: Sobre },
  { path: "/esquecisenha", component: EsqueciSenha },
  { path: "/perguntaspizza", component: PerguntasPizza },
  { path: "/email", component: AlterarEmail },
  { path: "/senha", component: AlterarSenha },
  { path: "/enderecos", component: ListaEndereco },
  { path: "/cadastro", component: Cadastro },
  { path: "/endereco", component: Endereco },
  /* { path: '/pedidos', component: Pedidos }, */
  { path: "/", component: Products },
  { path: "/perguntas", component: Perguntas },
  { path: "/produtounico", component: ProdutoUnico },
  { path: "/cart", component: Cart },
  { path: "/finalizadologin", component: FinalizadoLogin },
  { path: "/finalizadosemcadastro", component: FinalizadoSemCadastro },
  { path: "/pagamentopix", component: PagamentoPix },
];

// Register routes
export const router = new VueRouter({
  mode: "hash",
  routes,
});

Vue.use(VueAnalytics, {
  id: "G-VV9X7DS4ST",
  router,
});

Vue.directive("cleave", {
  inserted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {});
  },
  update: (el) => {
    const event = new Event("input", { bubbles: true });
    setTimeout(function () {
      el.value = el.cleave.properties.result;
      el.dispatchEvent(event);
    }, 100);
  },
});

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
